import { createApp } from 'vue';
import axios from 'axios'
import App from '@/App.vue';
import VueAxios from 'vue-axios'
import { createPinia, defineStore } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from '@/router'
import {useRoute, useRouter} from 'vue-router';
import BitEssential from '@bitroadie/bit-essential'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

import '@/css/app.scss';

const app = createApp(App);
app.config.globalProperties.window = window;

BitEssential.setup({
  auth_enabled : false,
  app_title : 'PrenotAI'
});

/*
BitEssential.setupSentry(app, {
  dsn: import.meta.env.VITE_SENTRY_DSN,
})
*/

BitEssential.setupAxios(axios);
BitEssential.setupPinia(defineStore);
BitEssential.setupRouter(router, useRoute, useRouter);
app.use(BitEssential);

app.use(pinia)
app.use(router)
app.use(VueAxios, axios)

// Mount the app
app.mount('#app');